import { render, staticRenderFns } from "./ItemSideMenu.vue?vue&type=template&id=cf70800a"
import script from "./ItemSideMenu.vue?vue&type=script&lang=js"
export * from "./ItemSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf70800a')) {
      api.createRecord('cf70800a', component.options)
    } else {
      api.reload('cf70800a', component.options)
    }
    module.hot.accept("./ItemSideMenu.vue?vue&type=template&id=cf70800a", function () {
      api.rerender('cf70800a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemSideMenu.vue"
export default component.exports